import { render, staticRenderFns } from "./EpotQuestionR.vue?vue&type=template&id=6c646920&"
import script from "./EpotQuestionR.vue?vue&type=script&lang=js&"
export * from "./EpotQuestionR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports